module.exports = __webpack_public_path__ + "static/media/slideMobile5.4b1b4839.jpg";